// extracted by mini-css-extract-plugin
module.exports = {"confirmContainer":"ConfirmCookies_confirmContainer__1_4qh","accept":"ConfirmCookies_accept__3smmq"};